























































import { Vue, Component } from 'vue-property-decorator';
import axios from 'axios';
import { delay } from '@/utils';

@Component
export default class LocalStorageTest extends Vue {
  storageKeys: string[] = [];
  storage: { setItem: Function; getItem: Function } = sessionStorage;
  accessToken: string | null = null;
  apiResult = {};

  mounted() {
    this.storage.setItem('test', true);
    this.storage.setItem('another', false);
    // Saving accessToken to track access Token change
    this.accessToken = this.storage.getItem('access_token');
    this.storageKeys = Object.keys(sessionStorage);
  }

  refreshToken() {
    // local storage update 후 클릭하면 웹뷰에서도 잘 긁어오는지 위한 기능 테스트
    this.accessToken = this.storage.getItem('access_token');
    this.refreshStorage();
  }

  refreshStorage() {
    this.storageKeys = Object.keys(sessionStorage);
  }

  async callUserMe() {
    await delay(() => window.config, window.config, 10);
    const res = (
      await axios.get(`${window.config.apiHost}/users/me`, {
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      })
    ).data.data;

    this.apiResult = res;
  }
}
